module.exports = __webpack_public_path__ + "img/table_collaborators.e76719b5.svg";